/* eslint-disable react/button-has-type */

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon, { IconType, IconSize } from '../icon/icon';
import {httpPost } from '../../../store/externalCalls/httpCalls';
import './customIframe.scss';
import { OverlayTrigger, Popover, Tooltip } from 'react-bootstrap';
import AlertsIcon from '../../atoms/customIcons/alertIcon.svg';


/**
 * Button is a basic HTML button with text and/or icon.
 * It can change the theme background, size and bind to parent function.
 */
const IframeCustom = (props) => {
  const {
    id,src,width,height
  } = props;

  const [isLoaded, setIsLoaded] = useState("");
  const [message,setMessage] =useState("");
  const [description,setDescription] =useState("");
  useEffect(()=>{
    let data={"src":src};
    httpPost("checkIFrame",data).then((res)=>{
      if(res.status=="ok"){
        setIsLoaded("ok");
        setMessage("");
      }
      else{
        setIsLoaded("refused");
        setMessage(res.message);
        setDescription(res.description);
      }
    }).catch(error=>{console.log("error",error)});
  },[]);
  const handleLoad = () => {
    // console.log("handler load");
    // Check if the iframe content was successfully loaded
    //curl
  };
  const handleError=()=>{
    console.log("error");
  }
  return (
    <>
    {isLoaded=="ok" && 
      <iframe
        id={id}
        src={src}
        title={"test"}
        width={width}
        height={height}
        onLoad={handleLoad}
        onError={handleError}
        seamless="seamless" 
        marginHeight="0" marginWidth="0" 
        scrolling="no" frameBorder="0" 
        allowtransparency="true" 
      />}
    {isLoaded=="refused" && <div className="customIframe iframe-refused"><div>
      <OverlayTrigger
        trigger={['hover', 'focus', 'click']}
        placement={"top"}
        overlay={(
          <Popover id="tooltip-left">
            <Popover.Content>
              {description}
            </Popover.Content>
          </Popover>
        )}
      > 
        <div><img className="alert-icon" src={AlertsIcon}/>{message}</div>
    </OverlayTrigger>
      
      </div></div>}  
    {isLoaded=="" && <div className="customIframe loading"><div>loading</div></div>}
    </>
  );
};


IframeCustom.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  src:PropTypes.string,
  title:PropTypes.string

};

IframeCustom.defaultProps = {
  width: '',
  height: '',
  src:'',
  title:''
};

export default IframeCustom;
